import { AccountGroupRole, State, StateAbbreviations, UserType } from '../enums';
import { formatPhoneNumber } from './StringUtils';

export const getAccountName = (
  user: {
    firstName?: string | null;
    lastName?: string | null;
    businessName?: string | null;
    telephone?: string | null;
    email?: string | null;
    externalId?: string | null;
    userType: UserType;
  },
  options?: {
    appendBusinessName?: boolean;
  },
) => {
  const isRetailerAdminUser = [
    UserType.SalesPerson,
    UserType.RetailerAdmin,
  ].includes(user.userType);

  const fullName = [user.firstName, user.lastName].filter(Boolean).join(' ') || null;

  const name = isRetailerAdminUser
    ? user.businessName || fullName
    : options?.appendBusinessName
      ? [fullName, user.businessName || null].filter(Boolean).join(' - ') || null
      : fullName || user.businessName;

  return [
    name,
    user.telephone ? formatPhoneNumber(user.telephone, 'paren') : undefined,
    user.email,
    user.externalId,
  ].find(Boolean) ?? '';
};

export function filterToViewableCustomers<
  T extends { id: string, accountGroupRole: AccountGroupRole | null }
> (
  customer: T,
  linkedAccounts: T[],
) {
  if (customer.accountGroupRole === AccountGroupRole.IndependentPartner) {
    return [customer];
  } else {
    return [
      customer,
      ...linkedAccounts.filter(({ id, accountGroupRole }) => (
        accountGroupRole !== AccountGroupRole.IndependentPartner
        && id !== customer.id
      )),
    ];
  }
}

export const getFormattedAddress = (
  user: { city: string | null, state: State | null },
): string => {
  let formattedAddress = '';
  const parsedState = user.state && StateAbbreviations[user.state];
  if (user.city) {
    formattedAddress = user.city;
  }
  if (user.city && parsedState) {
    formattedAddress += ', ';
  }
  if (parsedState) {
    formattedAddress += parsedState;
  }
  return formattedAddress;
};

/** The web app sends this on sign-in to get a Cognito session instead of LP's own token. */
export const CognitoSessionHeader = { name: 'x-lp-session', value: 'cognito' } as const;
